// extracted by mini-css-extract-plugin
export default {"container":"EditableDisabledCell_container__3AHYm","inside-row":"EditableDisabledCell_inside-row__6ADic"};